export default __webpack_public_path__ + "static/media/2053.e62f6881.png";